/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["__errors"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import { toIdSchema } from '../../utils/idUtils';
import { shouldDisplayLabelForSchema } from '../../utils/labelUtils';
import { getSchemaType, retrieveSchema } from '../../utils/schemaUtils';
import { getDefaultRegistry, mergeObjects } from '../../utils/defaults';
import { isEmptyArrayObjectField, isCrmPropertiesField, shouldUseJsonField } from '../../utils/typeUtils';
import { ADDITIONAL_PROPERTY_FLAG } from '../../utils/schemaUtils';
import COMPONENT_TYPES from '../../constants/ComponentTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ErrorList from '../ErrorList';
import UnsupportedField from './UnsupportedField';
import DefaultTemplate from './DefaultTemplate';
import { jsx as _jsx } from "react/jsx-runtime";
function getFieldComponent(schema, idSchema, name, parentSchemaType) {
  const schemaType = getSchemaType(schema);
  const componentName = COMPONENT_TYPES[schemaType];
  if (!componentName) {
    if (schema.anyOf || schema.oneOf) {
      return () => null;
    } else {
      return () => /*#__PURE__*/_jsx(UnsupportedField, {
        idSchema: idSchema,
        reason: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.params.errors.unknownFieldType",
          options: {
            type: schema.type || ''
          }
        }),
        type: schema.type
      });
    }
  }
  if (isCrmPropertiesField(schema, schemaType, idSchema, name) || shouldUseJsonField(schema, idSchema.$id) || isEmptyArrayObjectField(schema, schemaType, parentSchemaType)) {
    // Special case CRM object POST and PATCH properties fields, and some other object fields with many parameters
    return COMPONENT_TYPES.json;
  }
  return componentName;
}
class SchemaField extends Component {
  render() {
    const {
      errorSchema,
      disabled,
      formData,
      idPrefix,
      name,
      onKeyChange,
      registry = getDefaultRegistry(),
      required,
      schemaGroup,
      parentSchemaType
    } = this.props;
    const {
      definitions,
      formContext
    } = registry;
    const schema = retrieveSchema(this.props.schema, definitions, formData);
    if (Object.keys(schema).length === 0) {
      return null;
    }
    let idSchema = this.props.idSchema;
    idSchema = mergeObjects(toIdSchema(schema, null, definitions, formData, idPrefix), idSchema);
    const shouldDisplayLabel = shouldDisplayLabelForSchema(schema, definitions);
    const readOnly = Boolean(this.props.readOnly || this.props.schema.readOnly || schema.readOnly);
    const {
        __errors
      } = errorSchema,
      fieldErrorSchema = _objectWithoutPropertiesLoose(errorSchema, _excluded);
    const FieldComponent = getFieldComponent(schema, idSchema, name, parentSchemaType);
    const description = this.props.schema.description || schema.description;
    const label = this.props.schema.title || schema.title || name;
    const isAdditionalProperty = schema.hasOwnProperty(ADDITIONAL_PROPERTY_FLAG);
    const templateProps = {
      description,
      definitions,
      disabled,
      errors: /*#__PURE__*/_jsx(ErrorList, {
        errors: __errors
      }),
      formContext,
      id: idSchema.$id,
      label,
      onKeyChange,
      rawDescription: description,
      rawErrors: __errors,
      readOnly,
      required,
      schema,
      schemaGroup,
      shouldDisplayLabel
    };
    return /*#__PURE__*/_jsx(DefaultTemplate, Object.assign({}, templateProps, {
      children: /*#__PURE__*/_jsx(FieldComponent, Object.assign({}, this.props, {
        errorSchema: fieldErrorSchema,
        formContext: formContext,
        idSchema: idSchema,
        isAdditionalProperty: isAdditionalProperty,
        label: label,
        schema: schema,
        schemaGroup: schemaGroup,
        rawErrors: __errors,
        readOnly: readOnly,
        required: required
      }))
    }));
  }
}
SchemaField.propTypes = {
  autoFocus: PropTypes.bool,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  errorSchema: PropTypes.object,
  formData: PropTypes.any,
  idPrefix: PropTypes.string,
  idSchema: PropTypes.object.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyChange: PropTypes.func,
  readOnly: PropTypes.bool,
  registry: PropTypes.object.isRequired,
  required: PropTypes.bool,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string,
  parentSchemaType: PropTypes.string
};
SchemaField.defaultProps = {
  autoFocus: false,
  collapsed: true,
  disabled: false,
  errorSchema: {},
  idSchema: {},
  readOnly: false
};
export default SchemaField;